/*
  Module-reducer's action constants
*/

// Data actions
export const LOAD = 'myms/document/LOAD';
export const CREATE = 'myms/document/CREATE';
export const UPDATE = 'myms/document/UPDATE';
export const REMOVE = 'myms/document/REMOVE';

// Document actions
export const CANCEL = 'myms/document/CANCEL';
export const EDIT = 'myms/document/EDIT';
export const DONE = 'myms/document/DONE';
export const COMMIT_PUT = 'myms/document/COMMIT_PUT';

// Document view actions
export const SET_VIEW_ID = 'myms/document/SET_VIEW_ID';
export const CLEAR_VIEW_ID = 'myms/document/CLEAR_VIEW_ID';

// Document view actions
export const SET_DELETE_ID = 'myms/document/SET_DELETE_ID';
export const CLEAR_DELETE_ID = 'myms/document/CLEAR_DELETE_ID';
